import { MenuIdSettings } from '@jira/navigation-apps__constants/src/MenuIdSettings.tsx';
import { SidebarIdOperationsGeneralConfiguration } from '@jira/navigation-apps__constants/src/SidebarIdOperationsGeneralConfiguration.tsx';
import { getConsolidationStateResource } from '@jira/router-resources__eoc-tenant-info/src/getConsolidationStateResource.tsx';
import { navigationSidebarGlobalResource } from '@jira/router-resources__navigation-sidebar-global/src/navigationSidebarGlobalResource.tsx';
import { getNavigationResources } from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { opsSettingsLayout } from '@jira/platform__layouts-ops-settings-layout/src/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { eocCustomRolesRoute } from '@jira/router-routes__eoc-custom-roles-routes/src/eocCustomRolesRoute.tsx';
import { LazySidebarContent } from '@jira/navigation-apps__sidebar-nav4-sidebars-settings-global-operations/src/ui/index.tsx';
import { resources as customRoleResources } from '@atlassian/eoc-custom-roles/resources';
import type { Route, RouteResources } from '@atlassian/react-resource-router';
import CustomRoles, { LazyCustomRoles } from './ui/spa/eoc/custom-roles/index.tsx';

const getNavigationSpecifications = () => {
	return {
		sidebarId: SidebarIdOperationsGeneralConfiguration,
	};
};

export const eocCustomRolesRouteEntry: Route = createEntry(eocCustomRolesRoute, () => ({
	group: 'eoc',
	// eslint-disable-next-line no-restricted-syntax
	component: CustomRoles,
	layout: opsSettingsLayout,

	navigation: {
		menuId: MenuIdSettings,
		...getNavigationSpecifications(),
	},

	// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
	resources: [
		...getNavigationResources(),
		...customRoleResources(),
		getConsolidationStateResource(),
		navigationSidebarGlobalResource,
	] as RouteResources,

	forPaint: [LazySidebarContent, LazyAtlassianNavigation, LazyCustomRoles],

	bifrost: {
		bifrostGroup: 'shell-only',
	},
}));
